export class DispositifMin {
  constructor(public code: string, public libelle: string) {}
}
